<template>
    <b-modal v-model="modalMomento"
             :busy="true"
             centered
             hide-footer
             v-bind:title="Suscribirse">
        <div class="form-group text-center">
            <br>
            <label class="label-movistar">Cargando.</label>
            <br>
        </div>
    </b-modal>
</template>

<script>
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import numeral from "numeral";
import "numeral/locales";
numeral.locale("es");

export default {
    name: "LpEntel",
    components: {
        bModal,
    },
    directives: {
    },
    computed: {
    },
    watch: {

    },
    data() {
        return {
            valueHeader: false,
            tid: this.$route.query.tid,
            productId: this.$route.params.productId,
        };
    },
    methods: {
        async headerReqDatos() {
            this.$api
                .hearderReqDatos()
                .then(async (response) => { // Marca esta función anónima como async
                    if (response.data.msisdn !== "") {
                        this.valueHeader = true;
                        await this.tokenEmpello();
                        window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&msisdn=" + response.data.msisdn + "&ip=" + response.data.ip + "&schar=" + response.data.schar + "&status=1";
                    } else {
                        if (this.fe) {
                            window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&fe=" + this.fe + "&status=1";
                        } else {
                            window.location.href = "https://topclass.cl/lp/entel/" + this.productId + "?tid=" + this.tid + "&status=1";
                        }
                    }
                });
        },
        async tokenEmpello(){
            //let empelloToken = "";
            //empelloToken = await this.getEmepelloToken();
            this.$api
                .empelloToken({
                    telefono: this.telefono,
                    producto: this.producto
                })
                .then((response) => {
                    this.$log.warn('token empello ', response);
                    this.ejecutarCodigo(response.data.jsstring);
                    this.empello = response.data.token;
                    if (response.status === 101) {
                        // main JS loaded successfully
                    }
                    else if (response.status === 200 || response.status === 201) {
                        // Checks completed, journey can continue
                        if (!this.valueHeader) {
                            this.entelConfirmar();
                        }
                    }
                    else if (response.status === 202) {
                        // There was an error
                    }
                    else if (response.status === 203) {
                        // The JS function timed out
                    }
                });
        },
    },
    mounted() {
        this.headerReqDatos();
    },
    created() {

    },
};
</script>
